module.exports = __webpack_public_path__ + "static/media/LucasPao.7fdac4c2.JPG";